module.exports = __webpack_public_path__ + "static/image-ebook-d31bb656fc7ac4e5a38ae33a50d0846a.jpg";